document.addEventListener('DOMContentLoaded', function () {
    const navToggle = document.getElementById('navToggle');
    const mainNav = document.getElementById('mainNav');
    const navOverlay = document.getElementById('navOverlay');

    function openMenu() {
        mainNav.classList.add('open');
        navToggle.classList.add('open');
        navOverlay.classList.add('active');
        document.body.classList.add('nav-open');
    }

    function closeMenu() {
        mainNav.classList.remove('open');
        navToggle.classList.remove('open');
        navOverlay.classList.remove('active');
        document.body.classList.remove('nav-open');

        // Reset All Courses dropdown to collapsed state
        const coursesBtn = document.getElementById('coursesBtn');
        const coursePopup = document.getElementById('coursePopup');
        if (coursesBtn) coursesBtn.classList.remove('open');
        if (coursePopup) coursePopup.classList.remove('open');
    }

    function toggleMenu() {
        if (mainNav.classList.contains('open')) {
            closeMenu();
        } else {
            openMenu();
        }
    }

    if (navToggle) {
        navToggle.addEventListener('click', function (e) {
            e.stopPropagation();
            toggleMenu();
        });
    }

    // Close when clicking the overlay area
    if (navOverlay) {
        navOverlay.addEventListener('click', closeMenu);
    }

    // Close when clicking anywhere outside the mainNav sidebar
    document.addEventListener('click', function (event) {
        const isClickInsideMenu = mainNav.contains(event.target);
        const isClickOnToggle = navToggle.contains(event.target);

        if (!isClickInsideMenu && !isClickOnToggle && mainNav.classList.contains('open')) {
            closeMenu();
        }
    });

    // Close on link click
    const navLinks = mainNav.querySelectorAll('a:not(.dropdown-toggle)');
    navLinks.forEach(link => {
        link.addEventListener('click', closeMenu);
    });

    // Close on window resize if switching to desktop
    window.addEventListener('resize', () => {
        if (window.innerWidth > 768 && mainNav.classList.contains('open')) {
            closeMenu();
        }
    });
});